import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DropdownNavigation from './DropdownNavigation';
const displayName = 'DropdownFooter';
const Root = styled.div.withConfig({
  displayName: "DropdownFooter__Root",
  componentId: "sc-bw4bbj-0"
})(["border-top:1px solid var(--neutral-border);padding:var(--size-spacing-03) var(--size-spacing-04) var(--size-spacing-02);> ", "{width:calc(100% + 2 * var(--size-spacing-04));margin-left:calc(-1 * var(--size-spacing-04));&:first-child{margin-top:calc(-1 * var(--size-spacing-03));}&:last-child{margin-bottom:calc(-1 * var(--size-spacing-02));}}"], DropdownNavigation.Style);
const DropdownFooter = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref
  }), children);
});
DropdownFooter.displayName = displayName;
DropdownFooter.Style = Root;
process.env.NODE_ENV !== "production" ? DropdownFooter.propTypes = {
  /**
   * Sets the children.
   */
  children: PropTypes.node
} : void 0;
export default DropdownFooter;